export default class BaseView {
	constructor(container) {
		this.container = container;
		this.modules = [];
	}

	destroy() {
		this.modules.forEach((module) => {
			if (typeof module.destroy !== 'function') {
				return;
			}

			module.destroy();
		});
	}
}